import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TrainingCenterPageRoutingModule } from './training-center-routing.module';

import { TrainingCenterPage } from './training-center.page';
import { IonicRatingModule } from 'ionic4-rating';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CalendarModule } from "ion2-calendar";
import { InViewportModule } from 'ng-in-viewport';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TrainingCenterPageRoutingModule,
    IonicRatingModule,
    NgCircleProgressModule,
    CalendarModule,
    InViewportModule
  ],
  declarations: [TrainingCenterPage],
  exports: [TrainingCenterPage]
})
export class TrainingCenterPageModule {}
